import { NbToastrService, NbComponentStatus, NbGlobalPhysicalPosition } from '@nebular/theme';
import { Injectable } from '@angular/core';

@Injectable()
export class NotificationService {
    constructor(private toastrService: NbToastrService) { }

    types: NbComponentStatus[] = [
        'primary',
        'success',
        'info',
        'warning',
        'danger',
    ];

    showPrimary(mensaje: string, titulo?: string, duration?: number): void {
        this.showToast(this.types[0], titulo, mensaje, duration);
    }

  showSuccess(mensaje: string, titulo?: string, duration?: number): void {
        this.showToast(this.types[1], titulo, mensaje, duration);
    }

    showInfo(mensaje: string, titulo?: string, duration?: number): void {
        this.showToast(this.types[2], titulo, mensaje, duration);
    }

    showWarning(mensaje: string, titulo?: string, duration?: number): void {
        this.showToast(this.types[3], titulo, mensaje, duration);
    }

    showDanger(mensaje: string, titulo?: string, duration?: number): void {
        this.showToast(this.types[4], titulo, mensaje, duration);
    }

    private showToast(type: NbComponentStatus, title: string, body: string, duration: number) {
        const config = {
            status: type,
            destroyByClick: true,
            duration: duration ? duration : 7000,
            hasIcon: false,
            position: NbGlobalPhysicalPosition.TOP_RIGHT,
            preventDuplicates: false,
        };
        const titleContent = title ? `${title}` : '';
        this.toastrService.show(
            body,
            `${titleContent}`,
            config);
    }
}
